;(function ($, D) {

  "use strict";

  D.behaviors.searchBlock = {
    attach: function (context) {
      $(once('searchBlock', '.search-block-form', context)).addClass('searchBlock-processed').each(this.init)
        .closest('body').bind('click', this.collapser);
    },
    init: function (i, el) {
      var $el = $(el);

      $el.bind('click', D.behaviors.searchBlock.clickHandler);
    },
    clickHandler: function (e) {
      var $body, throwFocus;
      if (e.target === this) {
        $body = $('body');
        throwFocus = !$body.hasClass('searchBlock-active');
        $body.toggleClass('searchBlock-active');
        if (throwFocus) {
          $(this).find('.form-search').focus();
        }
      }
    },
    collapser: function (e) {
      if (!$(e.target).closest('.searchBlock-processed').length) {
        $('.searchBlock-active').removeClass('searchBlock-active');
      }
    }
  };

  D.behaviors.selectionSharer = {
    attach: function (context) {
      if (typeof selectionSharer !== 'undefined' && $.isFunction(selectionSharer)) {
        $('p').selectionSharer();
      }
    }
  };

  // Opening Campaign Social share block on small screens.
  D.behaviors.campaignSocialShare = {
    attach: function (context) {
      $('.campaign-social-share-link').on('click', function () {
        $('body.page-node-type-campaign').css('overflow', 'hidden');
        $('.campaign-social-share').addClass('is-campaign-social-share-visible');
      });

      $('.campaign-social-share, .campaign-social-share .icon-cancel').on('click', function (e) {
        if (e.target !== this)
          return;
        $('body.page-node-type-campaign').removeAttr('style');
        $('.campaign-social-share').removeClass('is-campaign-social-share-visible');
      });
    }
  }

  // Setting height for Campaign Hero image dependently of the window sizes.
  D.behaviors.campaignHeroImage = {
    attach: function (context) {
      var headerHeight;

      function fullscreen() {
        if ($(window).width() >= 767) {
          headerHeight = 72;
        } else {
          headerHeight = 60;
        }

        $('[class^="hero-image"]').css({
          width: $(window).width(),
          height: $(window).height() - headerHeight
        });
      }

      fullscreen();

      // Run the function in case of window resize
      $(window).resize(function () {
        fullscreen();
      });
    }
  };

  // Setting height for Campaign Hero video dependently of the window sizes.
  D.behaviors.campaignHeroVideo = {
    attach: function (context) {
      // Find all YouTube videos
      var $allVideos = $('.campaign-hero .videobg iframe');

      // When the window is resized.
      $(window).resize(function () {
        var newWidth = $(window).width();
        var newHeight = $(window).height();
        var aspectRatio = 1.7777777;

        // Resize all videos according to their own aspect ratio
        $allVideos.each(function () {
          var $el = $(this).parent();
          if ((newWidth / newHeight) < aspectRatio) {
            $el.height(newHeight).width(newHeight * aspectRatio)
          } else {
            $el.width(newWidth).height(newWidth * aspectRatio);
          }
        });
        // Kick off one resize to fix all videos on page load
      }).resize();
    }
  }

  // Building grid for Campaign Social Tiles after all Tile pictures are loaded
  D.behaviors.campaignSocialTiles = {
    attach: function (context) {
      var $target = $(once('social-tiles', '.social-tiles-grid', context));
      if ($target.length) {
        $target.imagesLoaded().always(function () {
          new AwesomeGrid('.social-tiles-grid', {
            desktop: 1024,
            tablet: 767
          })
            .gutters({
              column: 20,
              row: 40
            })
            .desktop(3)
            .tablet(2);
        });
      }

      // Opening FB share link in popup window
      $(once('myfeature', 'a.share', context)).click(function (e) {
        e.preventDefault();
        var $link = $(this);
        var href = $link.attr('href');
        var network = $link.attr('data-network');

        var networks = {
          facebook: {width: 600, height: 300}
        };

        var popup = function (network) {
          var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
          window.open(href, '', options + 'height=' + networks[network].height + ',width=' + networks[network].width);
        };
        popup(network);
      });
    }
  }

  // Making Campaign Header smaller after scrolling the page.
  D.behaviors.campaignHeader = {
    attach: function (context) {
      $(window).scroll(function () {
        var scrolled = $(this).scrollTop();
        if (scrolled >= 40) {
          $('.page-node-type-campaign #header-main').addClass('header-scrolled');
        } else {
          $('.page-node-type-campaign #header-main').removeClass('header-scrolled');
        }
      });
    }
  }

  // Setting slideshow on scroll for Campaign Reveal items.
  D.behaviors.campaignReveal = {
    attach: function (context) {
      if (typeof ScrollMagic !== 'undefined' && $.isFunction(scrollMagic)) {
        /**
         * Variables.
         *
         * $durationWindow - Animation duration window.
         * $items - Number of images in story container.
         */
        var $durationWindow = $(window).height();

        /**
         * Init controller.
         */
        var controller = new ScrollMagic.Controller();

        console.log("hello world");
        $(once('openReveal', '.component-reveal', context)).each(function () {
          var revealId = '#' + $(this).attr('id');

          var $items = $(revealId + ' .reveal-item').length - 1;

          /**
           * Add z-index to all items.
           */
          $.each($('.reveal-item'), function (key, value) {
            // Set specific value for z-index.
            var $index = ($items * 100) - (key * 10);
            $(this).css('z-index', $index);
          })

          /**
           * Build a scene.
           *
           * Story Container.
           */
          var storyContainerScene = new ScrollMagic.Scene({
            triggerElement: revealId,
            duration: $durationWindow * $items,
            triggerHook: 0
          })
            .setPin(revealId)
            .on("progress", function (event) {
              // Calculates current item id.
              var itemId = parseInt(($items * event.progress), 10) + 1;

              // Calculate item opacity.
              var calcOpacity = itemId - (event.progress * $items);

              // Return current item.
              var $currentItem = $(revealId + ' .reveal-item-' + itemId).find('.reveal-item-image');

              // Caption toggle class.
              var opacityProgress = itemId - $items * event.progress;

              if (opacityProgress < 0.2) {
                $('.reveal-caption').removeClass('reveal-caption');
                $($currentItem).parent().next().find('.caption').addClass('reveal-caption');
              } else if (opacityProgress > 0.8 && !($($currentItem).next('.caption').hasClass('reveal-caption'))) {
                $($currentItem).next('.caption').addClass('reveal-caption');
              }

              // Set Opacity --> force 0 or 1.
              $($currentItem).parent().prevAll().find('.reveal-item-image').css('opacity', '0');
              $($currentItem).parent().nextAll().find('.reveal-item-image').css('opacity', '1');

              // Set opacity.
              $($currentItem).css('opacity', calcOpacity);
            })
            .addTo(controller);
        });
      }
    }
  }
})(jQuery, Drupal);
